<div class="container">

  <div
    class="error-message"
    fxLayout="column"
    fxFlex="80%"
    *ngIf="formError && pageLoad && !activationError"
  >
    {{ formMessage }}
  </div>

  <div class="detailsContainer" *ngIf="!pageLoad">
    <h2>{{ labels.MEMBER_HEADER }}</h2>
    <p>
      {{ labels.MEMBER_DESCRIPTION }}
    </p>

    <div class="memberInfo">
      <div class="detailsGrid">
        <div class="detailsWrapper">
          <strong>{{ labels.MEMBER_FIRST_NAME }}</strong>
          <div>{{ memberDetails.firstName }}</div>
        </div>
        <div class="detailsWrapper">
          <strong>{{ labels.MEMBER_LAST_NAME }}</strong>
          <div>{{ memberDetails.lastName }}</div>
        </div>
        <div class="detailsWrapper">
          <strong>{{ labels.MEMBER_DOB }}</strong>
          <div>{{ memberDetails.dob }}</div>
        </div>
        <div class="detailsWrapper">
          <strong>{{ labels.MEMBER_GENDER }}</strong>
          <div>{{ memberDetails.gender | titlecase }}</div>
        </div>
        <div class="detailsWrapper">
          <strong><span>{{ labels.MEMBER_EMAIL }}</span> <span
            *ngIf="memberDetails.cardHolderType==='1001'">{{labels.MEMBER_PAYROLL_SYSTEM}}</span></strong>
          <div>{{ memberDetails.email }}</div>
        </div>
        <div class="detailsWrapper">
          <strong><span>{{ labels.MEMBER_MOBILE }}</span> <span
            *ngIf="memberDetails.cardHolderType==='1001'">{{labels.MEMBER_PAYROLL_SYSTEM}}</span></strong>
          <div>{{ memberDetails.mobile }}</div>
        </div>
      </div>
    </div>

    <div class="flexRow"
         *ngIf="userDetails.isSuccessFactorUser"
    >
      <div class="detailsWrapper">
        <strong><span>{{ labels.MEMBER_RESENDENTIAL_ADDRESS }}</span> <span
          *ngIf="memberDetails.cardHolderType==='1001'">{{labels.MEMBER_PAYROLL_SYSTEM}}</span></strong>
        <div>{{ mailingAddress }}</div>
      </div>
    </div>


    <h2 [style.margin-bottom]="'5px'">{{ labels.MEMBER_UPDATE_HEADER }}</h2>
    <p [style.margin-bottom]="'20px'">{{labels.MEMBER_UPDATE_DESCRIPTION}}</p>

    <div class="flexRow"
         *ngIf="!userDetails.isSuccessFactorUser"
         [formGroup]="memberAddressForm"
    >
      <div class="flexRow">
        <div class="flexColumn">
          <mat-form-field>
            <mat-label>{{ labels.MEMBER_UPDATE_ADDRESS_UNIT }}</mat-label>
            <input matInput formControlName="unitNo"/>
            <mat-error>{{
              labels.MEMBER_UPDATE_ADDRESS_UNIT_ERROR
              }}</mat-error>
          </mat-form-field>
        </div>
        <div class="flexColumn">
          <mat-form-field>
            <mat-label>{{
              labels.MEMBER_UPDATE_ADDRESS_STREET_NO
              }}</mat-label>
            <input matInput formControlName="streetNo"/>
            <mat-error>{{
              labels.MEMBER_UPDATE_ADDRESS_STREET_ERROR
              }}</mat-error>
          </mat-form-field>
        </div>
        <div class="flexColumn">
          <mat-form-field>
            <mat-label>{{
              labels.MEMBER_UPDATE_ADDRESS_STREET_NAME
              }}</mat-label>
            <input matInput formControlName="streetName"/>
            <mat-error>{{
              labels.MEMBER_UPDATE_ADDRESS_STREET_NAME_ERROR
              }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="flexRow"
         *ngIf="!userDetails.isSuccessFactorUser"
         [formGroup]="memberAddressForm"
    >
      <div class="flexRow">
        <div class="flexColumn">
          <mat-form-field>
            <mat-label>{{ labels.MEMBER_UPDATE_ADDRESS_SUBURB }}</mat-label>
            <input matInput formControlName="suburb"/>
            <mat-error>{{
              labels.MEMBER_UPDATE_ADDRESS_SUBURB_ERROR
              }}</mat-error>
          </mat-form-field>
        </div>
        <div class="flexColumn">
          <mat-form-field>
            <mat-label>{{ labels.MEMBER_UPDATE_ADDRESS_POSTCODE }}</mat-label>
            <input matInput formControlName="postcode"/>
            <mat-error>{{
              labels.MEMBER_UPDATE_ADDRESS_POSTCODE_ERROR
              }}</mat-error>
          </mat-form-field>
        </div>
        <div class="flexColumn">
          <mat-form-field>
            <mat-label>{{ labels.MEMBER_UPDATE_ADDRESS_STATE }}</mat-label>
            <mat-select formControlName="state" name="states">
              <mat-option *ngFor="let state of states" [value]="state">
                {{ state }}
              </mat-option>
            </mat-select>
            <mat-error>{{
              labels.MEMBER_UPDATE_ADDRESS_STATE_ERROR
              }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="flexRow"
         [formGroup]="memberPreferenceForm"
    >
      <div class="flexColumn">
        <mat-form-field>
          <mat-label>{{ labels.MEMBER_PREFERRED_MAIL }}</mat-label>
          <input matInput formControlName="email"/>
          <mat-error>{{ labels.MEMBER_PREFERRED_MAIL_ERROR }}</mat-error>
        </mat-form-field>
      </div>
      <div class="flexColumn">
        <mat-form-field>
          <mat-label>{{ labels.MEMBER_PREFERRED_MOBILE }}</mat-label>
          <input matInput formControlName="mobile"/>
          <mat-error>{{ labels.MEMBER_PREFERRED_MOBILE_ERROR }}</mat-error>
        </mat-form-field>
      </div>
    </div>


    <div [style.display]="'none'">
      <mat-checkbox
        [checked]="termsCheck"
        (change)="toggleTermsCheck($event.checked)"
      >
        {{ labels.MEMBER_OFFER_CHECKBOX }}</mat-checkbox
      >
    </div>


    <div class="user-hints" [style.display]="'none'">{{ labels.MEMBER_OFFER_CHECKBOX_TERMS }}</div>
    <div
      [ngClass]="mailingAddressError ? 'error-message' : ''"
      [innerHTML]="labels.MEMBER_SF_TERMS"
      *ngIf="this.userDetails.isSuccessFactorUser"
    ></div>
    <div class="error-message" *ngIf="activationError">
      {{ formMessage }}
    </div>
    <div class="buttonContainer">
      <button
        mat-raised-button
        class="submitButton"
        color="accent"
        [disabled]="validateForm() || loading"
        (click)="updateDetails()">
        <mat-spinner *ngIf="loading" diameter="20" mode="indeterminate"></mat-spinner>
        <span *ngIf="!loading">{{ labels.MEMBER_SUBMIT }}</span>
      </button>
    </div>
  </div>

  <!-- Spinner -->
  <div
    fxLayout="column"
    fxFlex="80%"
    *ngIf="pageLoad && !formError"
    class="pageSpinner"
  >
    <mat-spinner></mat-spinner>
  </div>
  <!-- Spinner -->
</div>
